interface CustomButtonProps {
    label: string;
    className?: string;
    onClick: () => void;
    disabled?: boolean;
}

const CustomButton: React.FC<CustomButtonProps> = ({
    label,
    className,
    onClick,
}) => {
    return (
        <div 
            onClick={onClick}
            className={`${className}`}
        >
            {label}
        </div>
    )
}

export default CustomButton;